import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-invoice',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.css']
})
export class ThankYouComponent implements OnInit {

  progress: boolean | number = false;

  constructor(private router: Router) { }

  ngOnInit() {
  }

  thankYou() {

    this.progress = 0;
    localStorage.removeItem('promotionProductsIds');
    window.location.href = environment.emblanoUrl;
  }

}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/shopping-cart/thank-you/thank-you.component.ts